import React from 'react';
import './ScrollWrap.css';

export default function ScrollWrap() {
  return (
    <div className='_scrollWrap d-flex gap-2 align-items-center'>
      <div className='_iconScroll'>Scroll down</div>
    </div>
  )
}
